module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.438fa4e0.svg";